import type { ApiClient } from "../../../infrastructure/http/apiClient";
import type {
  CreateAvailabilityInput,
  BookingPolicySnapshot,
  CreateResourceInput,
  CreateServiceInput,
  OnboardingSetupSnapshot,
  THHGOAvailability,
  THHGOResource,
  THHGOService
} from "../domain/setup";

export async function loadOnboardingSetup(apiClient: ApiClient): Promise<OnboardingSetupSnapshot> {
  const readiness = await apiClient.get<OnboardingSetupSnapshot["readiness"]>("/api/v1/setup/readiness");
  const bookingPolicy = await apiClient.get<BookingPolicySnapshot>("/api/v1/settings/booking-policy");
  const services = await apiClient.get<THHGOService[]>("/api/v1/services");
  const resources = await apiClient.get<THHGOResource[]>("/api/v1/resources");
  const availabilityGroups = await Promise.all(
    resources
      .filter((resource) => resource.active)
      .map((resource) => apiClient.get<THHGOAvailability[]>(`/api/v1/resources/${resource.id}/availability`))
  );

  return {
    readiness,
    timezone: bookingPolicy.timezone,
    services,
    resources,
    availability: availabilityGroups.flat()
  };
}

export function createFirstService(apiClient: ApiClient, input: CreateServiceInput): Promise<THHGOService> {
  return apiClient.post<THHGOService, CreateServiceInput>("/api/v1/services", input);
}

export function createFirstResource(apiClient: ApiClient, input: CreateResourceInput): Promise<THHGOResource> {
  return apiClient.post<THHGOResource, CreateResourceInput>("/api/v1/resources", input);
}

export function createInitialAvailability(apiClient: ApiClient, input: CreateAvailabilityInput): Promise<THHGOAvailability> {
  const { resourceID, ...body } = input;

  return apiClient.post<THHGOAvailability, typeof body>(`/api/v1/resources/${resourceID}/availability`, body);
}
